import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RequestCancelService {
  private cancel$ = new Subject<void>();

  cancelPendingRequests() {
    this.cancel$.next();
  }

  get cancelObservable(): Observable<void> {
    return this.cancel$.asObservable();
  }
}
